function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#00A1E0",
  d: "M6.54 1.2A2.754 2.754 0 018.533.344c1.037 0 1.942.579 2.424 1.437a3.35 3.35 0 011.37-.29c1.872 0 3.389 1.53 3.389 3.417 0 1.887-1.517 3.417-3.388 3.417-.225 0-.448-.022-.668-.066a2.476 2.476 0 01-3.245 1.02 2.826 2.826 0 01-5.253-.129 2.592 2.592 0 01-.539.057C1.174 9.207 0 8.02 0 6.557c0-.982.528-1.838 1.312-2.297A3.05 3.05 0 014.113 0c.99 0 1.87.47 2.427 1.2"
});

var SvgHappyLittleBlueCloud = function SvgHappyLittleBlueCloud(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11"
  }, props), _ref);
};

export default SvgHappyLittleBlueCloud;